import { useEffect } from 'react';

import useBranchId from '@maya/hooks/useBranchId';
import useTranslate from '@maya/hooks/useTranslate';
import { useAppDispatch, useAppSelector } from '@maya/store/hooks';
import { loadVisitType, selectVisitType } from '@maya/store/slices/visit-type';

export default function useVisitType(visitTypeId?: string) {
  const branchId = useBranchId();
  const t = useTranslate();

  const dispatch = useAppDispatch();
  useEffect(() => {
    if (!visitTypeId || !branchId) {
      return;
    }

    dispatch(loadVisitType(branchId, visitTypeId, t));
  }, [branchId, dispatch, t, visitTypeId]);

  return useAppSelector(selectVisitType);
}
